/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { useBlog } from '../Context'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'topics-list'

/**
 * This is the component description.
 */
const TopicsList = ({
  id,
  className:userClassName,
  style,
  items,
  Title,
}) => {
  const {
    generateBlogPath,
  } = useBlog()

  return (
    <div
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
        'hide-on-mobile',
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
    >
      { Title && Title }
      {items.map((post) => (
        <Link to={generateBlogPath('SINGLE', { slug: post.slug })} className="sluglink">
          <p>
            {post.title}
          </p>
        </Link>
      ))}
    </div>
  )
}

TopicsList.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  List of posts to render
   */
  items:PropTypes.arrayOf(PropTypes.shape({
    title      :PropTypes.string,
    mainImage  :PropTypes.string,
    slug       :PropTypes.string,
    description:PropTypes.string,
  })),

  /**
   * Title of the list
   */
  Title:PropTypes.node,
}

TopicsList.defaultProps = {
  // Title:<h4>Related Topics</h4>,
}

export default TopicsList
